<template>
  <div class="show-big-photo" @click="$emit('close')">
    <img :src="url" alt="">
  </div>
</template>

<script>
export default {
  props: ['url']
}
</script>

<style lang="scss" scoped>
.show-big-photo {
  width: 100%;
  height: 100vh;
  position: fixed;
  top: 0;
  background-color: rgba(0, 0, 0, .4);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9;

  img {
    width: 80%;
    height: 70%;
    object-fit: contain;
  }
}
</style>